import {Text, Tooltip} from '@chakra-ui/react'
import React from 'react'
import {FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import {useOrderSummary} from './order-summary-provider'
import {useD2BCustomer} from '../../hooks/use-d2b-customer'
import {InfoIconFilled} from '../icons'

const OrderSummaryVat = () => {
    const basket = useOrderSummary()
    const isD2BEnabled = useD2BCustomer().isCustomNetPriceEnabled
    const {formatNumber} = useIntl()

    return (
        <>
            {!isD2BEnabled && (
                <Text data-testid="taxtotal_text">
                    <FormattedMessage id="global.taxes" defaultMessage="Taxes" />
                </Text>
            )}
            {isD2BEnabled && (
                <Text data-testid="taxtotal_text">
                    <FormattedMessage id="global.taxes_vat" defaultMessage="VAT" />
                    {/*this works only if all products sold on STOKKE has the same taxrate*/}
                    {/*its alligned that this is the case for D2B MVP*/}
                    <Tooltip
                        hasArrow
                        placement="top"
                        label={formatNumber(basket.productItems?.[0].taxRate, {
                            style: 'percent'
                        })}
                    >
                        <InfoIconFilled variant="tooltip" />
                    </Tooltip>
                </Text>
            )}
            <Text data-testid="taxtotal_value">
                <FormattedNumber
                    value={basket.taxTotal}
                    style="currency"
                    currency={basket.currency}
                />
            </Text>
        </>
    )
}

export default OrderSummaryVat
